import Vue from "vue";
import dayjs from "dayjs";
import "dayjs/locale/es"; // carga bajo demanda

dayjs.locale("es"); // usar la configuración regional española globalmente

Vue.prototype.$dayjs = dayjs;